<template>
  <div class="card">
    <div
      class="card-body"
      :class="{
        active: marked
      }"
    >
      <input
        type="text"
        v-model.trim="websiteName"
        :placeholder="website.name"
        class="card-text"
        @keypress.enter="sendNewName"
      />
      <p class="card-text about">
        {{ website.about }}
      </p>
      <p class="card-text">
        <small class="text-muted"
          >Last updated {{ website.createdOn.seconds | date }}</small
        >
      </p>
      <div class="card-actions">
        <p class="mark-delete" @click="$emit('addToBulkDelete')">
          {{ marked ? "MARKED FOR DELETE" : "MARK FOR DELETE" }}
        </p>
        <p class="edit" @click="sendNewName" :class="{ editable: websiteName }">
          EDIT
        </p>
        <p class="delete" @click="$emit('deleteCard')">DELETE</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    website: {
      type: Object
    },
    marked: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      websiteName: null
    };
  },
  methods: {
    sendNewName() {
      if (!this.websiteName) {
        return;
      }
      const updatedImage = {
        id: this.website.id,
        name: this.websiteName
      };
      let confirm = window.confirm(
        "Are you sure you want to change " +
          this.website.name +
          " to " +
          this.websiteName
      );
      if (confirm) {
        this.$emit("updateName", updatedImage);
      }
      this.websiteName = null;
    }
  },
  filters: {
    date(value) {
      if (!value) return "";
      return new Date(value * 1000).toString().split("GMT")[0];
    }
  }
};
</script>

<style lang="scss" scoped>
.card {
  background: black;
  animation: slide-up 0.8s ease forwards;

  @keyframes slide-up {
    from {
      transform: translateY(100%);
    }
  }

  .card-body {
    height: 100%;

    input {
      background: none;
      border: none;
      color: rgba(white, 0.5);
      width: 100%;

      &::placeholder {
        opacity: 1;
      }

      &::selection {
        background-color: $primary;
      }
    }

    &.active {
      background: rgba($primary, 0.3);
    }

    .card-text {
      &.about {
        min-height: 100px;
      }
    }

    .card-actions {
      font-size: 0.8rem;
      font-weight: 700;
      cursor: pointer;
      display: flex;

      p {
        margin-right: 20px;
        transition: 0.2s all ease;

        &.mark-delete {
          color: $primary;
        }

        &.editable {
          color: green;
        }

        &.delete {
          &:hover {
            color: brown;
          }
        }
      }
    }
  }
}
</style>
